import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sort",
  "use": "icon-sort-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"icon-sort\">\n<path style=\"fill:#999999;\" d=\"M8.547,12.021h14.906c0.621,0,1.035-0.828,0.621-1.242L16.621,1.67c-0.414-0.207-0.828-0.207-1.242,0\n\tl-7.453,9.109C7.512,11.193,7.926,12.021,8.547,12.021z M23.453,18.853H8.547c-0.621,0-1.035,0.828-0.621,1.242l7.453,9.109\n\tc0.414,0.414,0.828,0.414,1.242,0l7.453-9.109C24.488,19.681,24.074,18.853,23.453,18.853z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol